import { Input, ChangeDetectorRef, Output, EventEmitter } from '@angular/core';
import { Component } from '@angular/core';

@Component({
  selector: 'ria-keyboard',
  templateUrl: 'ria-keyboard.html'
})
export class RiaKeyboardComponent {
  @Input() inputChosen: any;
  @Input() amount: any;
  @Input() inline: boolean = false;
  @Input() decimal: boolean = true;
  @Input() refControl = null;
  @Output() buttonClick: EventEmitter<any> = new EventEmitter();

  deviceLanguage: any;
  text: string;

  constructor(public cdRef: ChangeDetectorRef) {
    this.deviceLanguage = window.navigator.language;
  }

  addNumber(num: string) {
    if (this.refControl) {
      let value = this.refControl.value;
      if (this.refControl.getValue)
        value = this.refControl.getValue();
      if (!value)
        value = '';
      
      if (this.refControl.setValue)
        this.refControl.setValue(value + num);
      else
        this.refControl.value = value + num;
    }
    this.buttonClick.emit(num);
  }

  deleteNumber() {
    if (this.refControl) {
      if (this.refControl.setValue)
        this.refControl.setValue(this.refControl.getValue().substr(0, this.refControl.getValue().length - 1));
      else if (this.refControl.value)
        this.refControl.value = this.refControl.value.substr(0, this.refControl.value.length - 1);
    }
    this.buttonClick.emit('delete');
  }
}



// WEBPACK FOOTER //
// ./src/components/myria/ria-keyboard/ria-keyboard.ts